import clone from 'clone';
import * as is from 'Misc/is';
import { APPLICATION } from 'StateEvents';
import UpdateEvent from './UpdateEvent';
import defaultState from './DefaultState.json';
import { generateChangeLedger } from './Change';
import Throttleable from 'Services/Behaviors/Throttleable';

let managerInstance;
const UPDATE_INTERVAL_MS = 60;

// Similar to "Store" in Flux terminology - https://facebook.github.io/flux/docs/in-depth-overview.html#stores
export class StateManager extends Throttleable {
  constructor() {
    super(UPDATE_INTERVAL_MS);
    this.state = defaultState;
    this.timestampUpdate();
    this.consumers   = [];
    this.producers   = [];
    this.updateQueue = [];
  }

  update(event) {
    return new Promise((resolve, reject) => {
      event.resolver = resolve;
      this.updateQueue.push(event);
    });
  }

  nextTick() {
    if(this.updateQueue.length) {
      try {
        const prevState = this.state,
              nextState = this.nextEvents.reduce(this.reconcileUpdates.bind(this), clone(prevState, true, 2));

        const changeLedger = generateChangeLedger(nextState, prevState);

        this.consumers.forEach(this.propagateUpdates.bind(this, nextState, prevState, changeLedger));
        
        this.state = nextState;
        this.timestampUpdate();
      } catch(e) {
        console.error(e);
        this.update(new UpdateEvent(APPLICATION.ERROR, 'propagateUpdates', e.stack));
      }
      
    }
  }

  reconcileUpdates(state, event) {
    event.resolver && event.resolver();

    return (
      this
        .producers
        .reduce( (newState, producer) => {
          return producer.eventOccurred(newState, event);
        }, state)
    )
  }

  async propagateUpdates(nextState, prevState, changes, consumer, i) {
    try {
      await consumer.onUpdate(nextState, prevState, changes);
    } catch(e) {
      console.error(e);
      this.update(new UpdateEvent(APPLICATION.ERROR, 'propagateUpdates', e.stack));
    }
  }

  registerListener(fn, priority = -1) {
    if(fn.onUpdate && is.fun(fn)) {
      if(priority > -1) {
        this.consumers.splice(priority, 0, fn);
      } else {
        this.consumers.push(fn);
      }
    } else {
      console.warn('listener does not meet requirements', fn);
    }
  }

  unregisterListener(fn) {
    this.consumers = this.consumers.filter( consumer => consumer !== fn );
  }

  registerUpdater(fn) {
    this.producers.push(fn);
  }

  unregisterUpdater(fn) {
    this.producers = this.producers.filter( producers => producers !== fn );
  }

  timestampUpdate() {
    this.state.last_update = new Date().getTime();
  }

  get nextEvents() {
    return this.updateQueue.splice(0);
  }
}

export const getInstance = () => {
  if(!managerInstance) {
    managerInstance = new StateManager();
  }
  return managerInstance;
};


// WEBPACK FOOTER //
// ./src/Services/State/StateManager.js